export const DEFAULT_FILTER = {
  per_page: 25,
  page: 1,
};
